import { Skeleton } from "@mui/material";

function LoadingSkeleton({ size }) {
    return (
        <>
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            {
                Array.from({ length: size }).map(() => {
                    return (
                        <Skeleton variant="rectangular" height={100} />
                    )
                })
            }

        </>
    )
}

export default LoadingSkeleton;